"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EGroupPartition = exports.SortOrder = void 0;
const types_1 = require("@wix/ambassador-social-groups-v2-group/types");
exports.SortOrder = types_1.SortOrder;
var EGroupPartition;
(function (EGroupPartition) {
    EGroupPartition["ALL"] = "all";
    EGroupPartition["JOINED"] = "joined";
    EGroupPartition["SUGGESTED"] = "suggested";
})(EGroupPartition || (exports.EGroupPartition = EGroupPartition = {}));
//# sourceMappingURL=types.js.map